import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContenedorComponent } from '../contenedor/contenedor.component';
import { CatalogoDimensionesComponent } from './catalogo-dimensiones/catalogo-dimensiones.component';
import { authGuardSubmodule } from '../../auth/auth.guard';
import { ResultadosComponent } from './resultados/resultados.component';
import { MetodologiaComponent } from './metodologia/metodologia.component';
import { AnalisisCombinadoComponent } from './analisis-combinado/analisis-combinado.component';
import { PlanAccionComponent } from './plan-accion/plan-accion.component';
import { InformeComponent } from './informe/informe.component';
import { PerfilComponent } from './perfil/perfil.component';
import { SeguimientoPlanComponent } from './seguimiento-plan/seguimiento-plan.component';

const routes: Routes = [
  {
    path: 'app/clima-laboral',
    component: ContenedorComponent,
    children: [
      {path: 'metodologia', component: MetodologiaComponent, canActivate:[authGuardSubmodule]},
      {path: 'resultados', component: ResultadosComponent, canActivate:[authGuardSubmodule]},
      {path: 'analisis-combinado', component: AnalisisCombinadoComponent, canActivate:[authGuardSubmodule]},
      {path: 'catalogo-dimensiones', component: CatalogoDimensionesComponent, canActivate:[authGuardSubmodule]},
      {path: 'plan-accion', component: PlanAccionComponent, canActivate:[authGuardSubmodule]},
      {path: 'informe', component: InformeComponent, canActivate:[authGuardSubmodule]},
      {path: 'perfil', component: PerfilComponent, canActivate:[authGuardSubmodule]},
      {path: 'seguimiento-plan', component: SeguimientoPlanComponent, canActivate:[authGuardSubmodule]},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClimaLaboralRoutingModule { }
